module.exports = __webpack_public_path__ + "img/google_sync_created.8d015975.png";